import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as evaluacionService from "../../services/evaluacionService";
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import TemaEvaluacion from '../../components/TemaEvaluacion'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsTema } from '../../redux/evaluacionSlice';

// Mantenimiento de los temas de evaluacion: el catalogo jerarquico.
const Edit = () => {
    const tema = useSelector((state) => state.evaluacion.entity);
    const temaValidation = useSelector((state) => state.evaluacion.validationMessage);

    const [openMessage, setOpenMessage] = useState(false)
    const onCloseMessage = () => { setOpenMessage(!openMessage); }
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
    const dispatch = useDispatch();
    const params = useParams();
    const { isReadOnly, setIsReadOnly } = useMantenimiento("evaluacion");

    const mensaje = (severity, texto) => {
        setPropsMessage({ severity: severity, message: texto })
        setOpenMessage(true);
    }

    const postEntity = async () => {
        if (temaValidation.length > 0) {
            dispatch(activeValidationsTema());
            mensaje("error", temaValidation.join(" - "))
            return;
        }

        try {
            await evaluacionService.addUpdateTemaEvaluacion({
                id: tema.id,
                nombre: tema.nombre,
                descripcion: tema.descripcion,
                idTemaPadre: tema.idTemaPadre,
                orden: tema.orden,
                idEstado: tema.idEstado,
            })

            mensaje("success", "Se guardaron los datos con exito")
            setIsReadOnly(true)
        }
        catch (err) {
            console.log("Err: ", err);
            mensaje("error", "Hubo un error al guardar")
        }
    }

    return (
        <div>
            <MantenimientoForm
                title={(parseInt(params.id) === 0 ? "Nuevo" : "Editar") + " Tema de Evaluacion"}
                backTo={"/evaluacion/temas"}
                onSave={postEntity}
                disabled={isReadOnly}
            >
                <Grid container spacing={1} sx={{
                    "& .MuiGrid-root>.MuiGrid-item": {
                        paddingTop: "8px"
                    },
                }}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                                <TemaEvaluacion isReadOnly={isReadOnly} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </MantenimientoForm>
            <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                    {propsMessage.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default Edit
